import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Nahra Solution';
  isLoggedIn: any;

  constructor() {
    this.isLoggedIn = localStorage.getItem('isLoggedIn');
  }
}
